import React, { useEffect, useState } from 'react';

import { IMaskInput } from 'react-imask';

import { Dialog, DialogTitle, DialogContent, Switch, Grid, Box } from '@mui/material';
import { DialogActions } from '@mui/material';
import { TextField } from '@mui/material';
import { FormHelperText } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';


import '../../../../index.css';
import api from '../../../../api';
import Table from "../../../Table";

const EditGroupMembersModal = (props) => {
    const [clientGroupName, updateClientGroupName] = useState("")
    const [clientGroupDescription, updateClientGroupDescription] = useState("")
    const [clientGroupIds, updateClientGroupIds] = useState([])
    const [clientsObj, updateClientsObj] = useState({})
    const [clientsTableColumns, updateClientsTableColumns] = useState([])
    const [clientsFilter, updateClientsFilter] = useState({ items: [] })
    const [selectionModel, updateSelectionModel] = useState([])
    const [nextPage, updateNextPage] = useState(null)
    const [ready, updateReady] = useState(false)


    const fetchClientGroupIds = async () => {
        if (props.groupId === 0) {
            return
        }
        const url = `/api/enterprises/${props.enterpriseId}/contact_group/${props.groupId}/`

        const response = await api.get(url)
        if (response.status === 404) {
            return
        }
        updateClientGroupIds(response.data.contacts.map(each => each.contact));
    }


    const submit = async () => {
        const url = `/api/enterprises/${props.enterpriseId}/contact_group/${props.data.id}/`
        const body = {
            name: clientGroupName,
            description: clientGroupDescription,
            clients: selectionModel
        }
        const response = await api.patch(url, body)
        if (response.status === 404) {
            // console.log('Response Fail') // chamar o notification padrão
            return
        }
        props.submit()
    }

    useEffect(() => {
        fetchClientGroupIds()
        updateReady(false)
    }, [props.groupId])


    useEffect(() => {
        updateClientGroupName(props.data.name)
        updateClientGroupDescription(props.data.description)
        updateClientsObj(mapClients(props.clients))
        updateClientsTableColumns(createClientsColumns(props.clients))
        updateSelectionModel(clientGroupIds)
        updateReady(true)
    }, [clientGroupIds])


    const createClientsColumns = (clients) => {
        
		

        // Blocking sorting for integrations
        const sortable = true;

        let columns = [
            { field: 'name', headerName: 'Nome', flex: 1, sortable: sortable },
            { field: 'telephone', headerName: 'Telefone', flex: 1, sortable: sortable },
            {
                field: 'id', headerName: 'Pertence ao segmento', flex: 1, sortable: sortable, hide: true,
                valueGetter: ({ value }) => {
                    return clientGroupIds.includes(value)
                },
            },
        ];

        return columns;

    }

    const mapClients = (clients) => {
        const clientsObj = {};

        clients.forEach((client) => {
            clientsObj[client.id] = client
        })

        return clientsObj;
    }


    const buildClients = () => {


        createClientsColumns(props.clients)

        return (
            <Table
                label={"Clientes"}
                columns={clientsTableColumns}
                rows={props.clients}
                checkboxSelection={true}
                pagination={false}
                pageSize={null}
                onSelectionModelChange={(newSelectionModel) => {
                    updateSelectionModel(newSelectionModel);
                }}
                filterMode="client"
                selectedItems={selectionModel}
                initialSort={[{ field: 'id', sort: 'desc' }]}
            />
        );
    }
	



    const onFilterChange = async (filterModel) => {
        let query = "";

        filterModel['items'].forEach((filter) => {
            let field = filter.columnField;
            let value = filter.value;

            // Rename Zendesk phone field
            field = (field === 'telephone') ? 'phone' : field;

            if (value !== undefined)
                query += `${field}:\"${value}\" `;
        });

        query = query.slice(0, -1);

        searchClients(query, filterModel);
    }


    const searchClients = async (query, filterModel) => {
        if (!query) {
            await updateClientsFilter(filterModel);
            // await this.setState({ clientsFilter: filterModel });
            // await this.getClients();

            return;
        }

        // this.setState({ loading: true });

        // TODO: Adapt for other CRM integrations
        // currently only querying Zendesk
        // api.post(`/api/enterprises/${this.enterpriseId}/contacts/zendesk/search/`, {
        // 	filter_type: 'user',
        // 	page_size: this.pageSize,
        // 	query: query
        // }).then((res) => {
        // 	if (res.status === 200 && this._isMounted) {
        // 		const clients = this.getZendeskClients(res.data);
        // 		const clientsObj = this.mapClients(clients);

        // 		const hasMore = res.data['meta']['has_more'];

        // 		this.setState({
        // 			loading: false,
        // 			clients: clients,
        // 			clientsObj: clientsObj,
        // 			prevPage: res.data['links']['prev'],
        // 			nextPage: (hasMore) ? res.data['links']['next'] : null,
        // 			clientsFilter: filterModel
        // 		});

        // 		return;
        // 	}
        // 	throw res;
        // }).catch(async (err) => {
        // 	console.error(err);

        // 	this.setState({ loading: false });

        // 	await useNotification(
        // 		'Ops!',
        // 		'Ocorreu um erro no sistema',
        // 		'danger'
        // 	);
        // });
    }


    const customRow = (props) => {
        const list_index = props.index;
        const list_size = props.clients.length;
        const value_opacity = list_size - list_index;

        return (
            <GridRow
                {...props}
                style={{
                    opacity:
                        (value_opacity < 10 && nextPage) ?
                            `0.${value_opacity}` : null
                }}
            />
        );
    }

    return (
        <div>
            {ready &&
                <Dialog keepMounted
                    open={props.open}
                    onClose={props.handleClose}
                    aria-labelledby="customized-dialog-title"
                    fullWidth
                    disablePortal
                    disableEnforceFocus
                    sx={{position:'absolute'}}
                >
                    <DialogTitle id="customized-dialog-title">
                        {props.title}
                    </DialogTitle>
                    <DialogContent>

                        <>
                            <div className='tableWrapper'>
                                {buildClients()}
                            </div>
                        </>
                    </DialogContent>

                    <DialogActions style={{ padding: "10px 20px 10px 10px" }}>
                        <LoadingButton
                            onClick={() => submit()}
                            color="primary"
                            
                        >
                            {props.buttonText}
                        </LoadingButton>
                    </DialogActions>
                </Dialog>
            }
        </div>
    )
}

export default EditGroupMembersModal
